import { render, staticRenderFns } from "./AbnormalSubmit.vue?vue&type=template&id=4d370c4e&scoped=true&"
import script from "./AbnormalSubmit.vue?vue&type=script&lang=js&"
export * from "./AbnormalSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d370c4e",
  null
  
)

export default component.exports